module.exports = __webpack_public_path__ + "static/media/title-banner-2.b35b0bab.png";